module.exports = __webpack_public_path__ + "static/media/LogoIcon@3x.5ecfa351.png";